import React from 'react'
import PropTypes from 'prop-types'

import ModuleContainer from '../../_layout/Module/ModuleContainer'
import LinkHeadline from '../../molecules/LinkHeadline/LinkHeadline'
import { SecondaryButton } from '@aok/ui-elements'
import defaultProps from '../../../utils/propTypes/defaultProps'

const Y007S = ({ headline, elements }) => {
  return (
    <div
      className={`y007 -s
      w-full
      py-64
      720:py-80
      1000:py-112
      bg-e8f4f2
    `}
    >
      <ModuleContainer dataTrackingName="Y007">
        <div
          className="
          grid grid-cols-4 gap-16 gap-y-24
          600:grid-cols-8 600:gap-y-32
          720:gap-x-24
          840:grid-cols-12
          1000:gap-x-32
        "
        >
          <LinkHeadline
            headline={headline}
            className="col-span-4 600:col-start-2 600:col-end-8 840:col-start-3 840:col-end-11"
          />
          <div
            className="
            flex flex-wrap gap-16
            col-span-4
            600:col-start-2 600:col-end-8
            840:col-start-3 840:col-end-11
          "
          >
            {elements.map((element, index) => {
              return (
                <SecondaryButton key={index} url={element.url} className="hyphens inline-flex items-center">
                  {element.title}
                </SecondaryButton>
              )
            })}
          </div>
        </div>
      </ModuleContainer>
    </div>
  )
}

Y007S.propTypes = {
  headline: PropTypes.shape({
    text: PropTypes.string,
  }),
  elements: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  settings: PropTypes.shape({
    indented: PropTypes.bool,
    variant: PropTypes.string,
  }),
}

Y007S.defaultProps = {
  headline: {
    text: defaultProps.HEADLINE,
  },
  elements: [
    {
      text: defaultProps.HEADLINE,
      url: defaultProps.URL,
    },
    {
      text: defaultProps.HEADLINE,
      url: defaultProps.URL,
    },
    {
      text: defaultProps.HEADLINE,
      url: defaultProps.URL,
    },
    {
      text: defaultProps.HEADLINE,
      url: defaultProps.URL,
    },
    {
      text: defaultProps.HEADLINE,
      url: defaultProps.URL,
    },
    {
      text: defaultProps.HEADLINE,
      url: defaultProps.URL,
    },
  ],
  settings: {
    variant: 'small',
    indented: false,
  },
}

export default Y007S
